import { KeyCloakRealm } from '@tecsinapse-org/keycloak-unified-authentication'
import { store, STORES } from '@/core/data/storage'

export type KeycloakInfo = Pick<
  KeyCloakRealm,
  'loginUrl' | 'realm' | 'clientId'
>

export const setAndRedirect = (keycloakInfo: KeyCloakRealm | KeycloakInfo) => {
  const kcInfo: KeycloakInfo = {
    realm: keycloakInfo.realm,
    clientId: keycloakInfo.clientId,
    loginUrl: keycloakInfo.loginUrl
  }
  store(STORES.KEYCLOAK, kcInfo)
  window.location.href = keycloakInfo.loginUrl
}

const REALM_LABEL = new Map<string, string>([
  ['Chevrolet', 'Portal Tecsinapse']
])

export const keyExtractor = (e: KeyCloakRealm) => e.realm

export const labelExtractor = (e: KeyCloakRealm) =>
  REALM_LABEL.get(e.realm) ?? e.realm
